/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { FiUploadCloud } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { AddProductImage, getProduct, handleAddProduct } from "../../Redux/ProductSlice";
import { getAllCategory, getAllVisibleTo, getCurrency } from "../../Redux/CommonSlice";
import ReactSelect from "../Common/ReactSelect";
import AddCategory from "../Common/AddCategory";
import { formatNumber } from "../Common/Common";
import { AddRowBtn, DeleteBtn } from "../Common/Buttons";

const MAX_IMAGE_SIZE_MB = 15;
const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;

export default function AddProduct({ toggleModal, product }) {
  const dispatch = useDispatch();
  const imageInputRef = useRef(null);
  const [loadFist, setLoadFist] = useState(true);
  const { register, handleSubmit, setValue, formState: { errors }, clearErrors } = useForm();
  const storecommon = useSelector((state) => state.root.common);
  const modalTitle = product?.productID ? "Update Product" : "Add Product";

  const [selectedCurrency, setSelectedCurrency] = useState({ value: 63, label: "Indian Rupee(INR)", });
  const [selectedVisible, setselectedVisible] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [openCategoryModal, setOpenCategoryModal] = useState(false);
  const [allUnitPrice, setAllUnitPrice] = useState([{
    unitprice: 0, cost: 0, currencyID: selectedCurrency.value, currencyName: selectedCurrency.label,
  }]);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [isImageDragOver, setIsImageDragOver] = useState(false);

  useEffect(() => {
    if (loadFist) {
      dispatch(getCurrency({}));
      dispatch(getAllVisibleTo({}));
      dispatch(getAllCategory({}));
      setLoadFist(false);
    }
  }, [storecommon, loadFist]);

  useEffect(() => {
    if (product) {
      setValue("Name", product?.name);
      setValue("productCode", product?.productCode);
      setValue("Unit", product?.unit);
      setValue("UnitPrices", product?.unitPrice);
      setValue("Tax", product?.taxper);
      setValue("Currency", product?.priceType);
      setValue("Category", product?.category);
      setValue("Description", product?.description || "");

      if (product && product?.visibleToID) setselectedVisible({ label: product?.visibleName, value: product?.visibleToID, });
      if (product && product?.categoryID) setSelectedCategory({ label: product?.categoryName, value: product?.categoryID, });

      if (product?.productPrice?.length > 0) {
        setAllUnitPrice(product?.productPrice.map((x) => ({ unitprice: x?.unitprice, cost: 0, currencyID: x?.currencyID, directCost: 0, currencyName: x?.currencyName })))
      }

      if (product?.filePath) {
        setImagePreview(product.filePath);
        setImageFile(null);
      }
    }
  }, [product]);

  useEffect(() => {
    return () => {
      if (imagePreview?.startsWith("blob:")) URL.revokeObjectURL(imagePreview);
    };
  }, [imagePreview]);

  const handleVisibleChange = (option) => { setselectedVisible(option); };

  const applyImageFile = (file) => {
    if (!file) return;
    if (!file.type?.startsWith("image/")) {
      toast.error("Please select an image file.");
      return;
    }
    if (file.size > MAX_IMAGE_SIZE_BYTES) {
      toast.error(`Maximum upload file size is ${MAX_IMAGE_SIZE_MB} MB.`);
      return;
    }
    if (imagePreview?.startsWith("blob:")) URL.revokeObjectURL(imagePreview);
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleImageInputChange = (e) => {
    applyImageFile(e.target.files?.[0]);
    if (imageInputRef.current) imageInputRef.current.value = "";
  };

  const clearSelectedImage = () => {
    if (imagePreview?.startsWith("blob:")) URL.revokeObjectURL(imagePreview);
    setImageFile(null);
    setImagePreview(product?.filePath || "");
  };

  const currencyOptions = storecommon && storecommon?.getCurrency?.length > 0 ? storecommon?.getCurrency?.map((item) => ({
    value: item?.value,
    label: item?.text,
    icon: item?.type,
    isDisabled: allUnitPrice.some((x) => x?.currencyID === item?.value),
  })) : [{ value: "", label: "Not Found" }];

  useEffect(() => {
    if (currencyOptions?.length > 0) {
      const indianRupee = currencyOptions?.find((x) => { return x?.label === "Indian Rupee(INR)" && !x?.isDisabled })
      const initialCurrency = indianRupee || currencyOptions?.find(option => !option?.isDisabled) || currencyOptions[0];
      setSelectedCurrency(initialCurrency)
    }
  }, [storecommon?.getCurrency]);

  const handleFieldChange = (index, fieldName, value, option) => {
    if (fieldName === 'unitprice') {
      const rawValue = value.replace(/[^0-9]/g, '');
      value = rawValue
    }

    const updatedUnitPrices = [...allUnitPrice];
    updatedUnitPrices[index] = { ...updatedUnitPrices[index], [fieldName]: value };
    if (fieldName === 'currencyID') {
      updatedUnitPrices[index].currencyName = option?.label ? option?.label : 'Indian Rupee';
    }
    setAllUnitPrice(updatedUnitPrices);
  };

  const resolveProductId = (res) => {
    const data = res?.payload?.data;
    if (data?.productID) return data.productID;
    if (typeof data === "number") return data;
    return product?.productID || null;
  };

  const onSubmit = async (data) => {
    const Params = {
      productID: product && product.productID ? product.productID : 0,
      name: data?.Name,
      productCode: data?.productCode,
      categoryID: selectedCategory?.value,
      unit: data?.Unit,
      unitPrice: data?.UnitPrices,
      taxper: data?.Tax,
      visibleToID: selectedVisible.value,
      description: data?.Description || "",
      isactive: true,
      productPrice: allUnitPrice,
    };

    try {
      const res = await dispatch(handleAddProduct(Params));
      if (res?.payload?.status !== true) return;

      const productId = resolveProductId(res);
      if (imageFile && productId) {
        const formData = new FormData();
        formData.append("file", imageFile);
        await dispatch(AddProductImage({ payload: productId, data: formData }));
      }

      dispatch(getProduct({}));
      toggleModal();
      setSelectedCurrency("");
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <div
        id="default-modal"
        tabIndex="-1"
        aria-hidden="true"
        className="lead-modal-backdrop"

      >
        <div className="lead-modal-shell">
          <div className="lead-modal-card">
            <div className="lead-modal-header">
              <div>
                <h3 className="lead-modal-title">{modalTitle}</h3>
              </div>
              <AiOutlineCloseCircle
                className="lead-modal-close"
                onClick={toggleModal}
              />
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="lead-modal-body">
                <div className="lead-modal-grid vertical-scroll-inner">
                  <div className="lead-modal-section">
                    <div className="lead-modal-section-header">
                      <span className="lead-modal-section-dot" />
                      <h4>Product details</h4>
                    </div>
                    <div className="lead-modal-section-content">
                      <div className="lead-modal-field">
                        <label htmlFor="Name" className="lead-modal-label">Name</label>
                        <input
                          type="text"
                          {...register("Name", { required: "Product Name is Required" })}
                          name="Name"
                          id="Name"
                          className="lead-modal-input capitalize"
                          placeholder="Enter Product Name"
                        />
                        {errors.Name && <span className="lead-modal-error">{errors.Name.message}</span>}
                      </div>
                      <div className="lead-modal-field">
                        <label htmlFor="productCode" className="lead-modal-label">Product code</label>
                        <input
                          type="number"
                          min="0"
                          {...register("productCode")}
                          className="lead-modal-input"
                          placeholder="Enter Product code"
                        />
                      </div>
                      <div className="lead-modal-field">
                        <label htmlFor="Unit" className="lead-modal-label">Quantity</label>
                        <input
                          type="number"
                          min="0"
                          {...register("Unit", { required: "Unit is Required" })}
                          name="Unit"
                          id="Unit"
                          className="lead-modal-input"
                          placeholder="Enter Unit"
                        />
                        {errors?.Unit && <span className="lead-modal-error">{errors.Unit.message}</span>}
                      </div>
                      <div className="lead-modal-field">
                        <label htmlFor="Tax" className="lead-modal-label">Tax %</label>
                        <input
                          type="number"
                          min="0"
                          {...register("Tax", { required: "Tax is Required" })}
                          name="Tax"
                          id="Tax"
                          className="lead-modal-input"
                          placeholder="Enter Tax %"
                        />
                        {errors.Tax && <span className="lead-modal-error">{errors.Tax.message}</span>}
                      </div>
                      <div className="lead-modal-field">
                        <label htmlFor="Category" className="lead-modal-label">Category</label>
                        <div className="lead-modal-inline-control">
                          <ReactSelect
                            selectedValue={selectedCategory}
                            options={storecommon && storecommon?.getCategorys.length > 0
                              ? storecommon?.getCategorys.map((item) => ({
                                value: item?.categoryID,
                                label: item?.categoryName,
                              }))
                              : [{ value: "", label: "Not Found" }]}
                            handleSelectChange={(option) => setSelectedCategory(option)}
                          />
                          <AddRowBtn label="Category" onClick={() => setOpenCategoryModal(true)} />
                        </div>
                      </div>
                      <div className="lead-modal-field">
                        <label htmlFor="Visible to" className="lead-modal-label">Visible to</label>
                        <ReactSelect
                          selectedValue={selectedVisible}
                          options={storecommon && storecommon?.getAllVisibleTo.length > 0
                            ? storecommon?.getAllVisibleTo.map((item) => ({
                              value: item?.value,
                              label: item?.text,
                            }))
                            : [{ value: "", label: "Not Found" }]}
                          handleSelectChange={handleVisibleChange}
                        />
                      </div>
                      <div className="lead-modal-field">
                        <label htmlFor="Description" className="lead-modal-label">Description</label>
                        <textarea
                          id="Description"
                          {...register("Description")}
                          className="lead-modal-input task-modal-textarea"
                          placeholder="Enter product description..."
                          rows={4}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="lead-modal-section">
                    <div className="lead-modal-section-header">
                      <span className="lead-modal-section-dot lead-modal-section-dot-blue" />
                      <h4>Pricing details</h4>
                    </div>
                    <div className="lead-modal-section-content">
                      {allUnitPrice?.map((item, index) => (
                        <div className="lead-modal-row" key={index}>
                          <div className="lead-modal-field">
                            <label htmlFor={`UnitPrices_${index}`} className="lead-modal-label">Unit Prices</label>
                            <input
                              type="text"
                              {...register(`UnitPrices_${index}`, { required: "Unit Price is Required" })}
                              name={`UnitPrices_${index}`}
                              id={`UnitPrices_${index}`}
                              className="lead-modal-input"
                              placeholder="Enter Unit prices"
                              min="0"
                              value={formatNumber(item?.unitprice || '')}
                              onChange={(e) => {
                                handleFieldChange(index, 'unitprice', e.target.value);
                                clearErrors(`UnitPrices_${index}`);
                              }}
                            />
                            {errors[`UnitPrices_${index}`] && <span className="lead-modal-error">{errors[`UnitPrices_${index}`]?.message}</span>}
                          </div>
                          <div className="lead-modal-field">
                            <label htmlFor={`Currency_${index}`} className="lead-modal-label">Currency</label>
                            <div className="flex items-start gap-2">
                              <div className="min-w-0 flex-1">
                                <ReactSelect
                                  Clearable={false}
                                  selectedValue={storecommon?.getCurrency?.find(x => x?.value === item?.currencyID)
                                    ? { value: item?.currencyID, label: item?.currencyName, icon: storecommon?.getCurrency?.find(x => x?.value === item?.currencyID)?.type }
                                    : null}
                                  options={currencyOptions}
                                  handleSelectChange={(option) => handleFieldChange(index, 'currencyID', option?.value, option)}
                                />
                              </div>
                              {allUnitPrice.length > 1 && (
                                <DeleteBtn
                                  onClick={() => setAllUnitPrice((prev) => prev.filter((_, i) => i !== index))}
                                />
                              )}
                              {index === allUnitPrice.length - 1 && (
                                <AddRowBtn
                                  label="Price"
                                  onClick={() => {
                                    if (!currencyOptions?.length) return;
                                    const indianRupee = currencyOptions.find((option) => option?.value === 63 && !option?.isDisabled);
                                    const initialCurrency = indianRupee || currencyOptions.find((option) => !option?.isDisabled) || currencyOptions[0];
                                    setAllUnitPrice((prev) => [
                                      ...prev,
                                      { unitprice: 0, cost: 0, currencyID: initialCurrency?.value, currencyName: initialCurrency?.label },
                                    ]);
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ))}

                      <div className="lead-modal-field">
                        <label className="lead-modal-label">Product image</label>
                        <input
                          ref={imageInputRef}
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={handleImageInputChange}
                        />
                        {imagePreview ? (
                          <div className="flex flex-col gap-2.5 p-3 border border-slate-200 rounded-xl bg-white">
                            <img src={imagePreview} alt="Product preview" className="w-full max-h-[220px] object-contain rounded-lg bg-slate-50" />
                            <div className="flex items-center gap-2">
                              <button
                                type="button"
                                className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-indigo-200 rounded-lg bg-indigo-50 hover:bg-indigo-100 hover:border-indigo-300 text-indigo-700 text-xs font-semibold cursor-pointer transition-colors"
                                onClick={() => imageInputRef.current?.click()}
                              >
                                Change
                              </button>
                              {imageFile && (
                                <button
                                  type="button"
                                  className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-red-200 rounded-lg bg-red-50 hover:bg-red-100 hover:border-red-300 text-red-600 text-xs font-semibold cursor-pointer transition-colors"
                                  onClick={clearSelectedImage}
                                  aria-label="Remove selected image"
                                >
                                  <RiDeleteBinLine size={14} />
                                  Remove
                                </button>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div
                            className={`flex flex-col items-center justify-center gap-1.5 min-h-[160px] px-4 py-5 border-2 border-dashed rounded-xl cursor-pointer transition-colors text-center ${
                              isImageDragOver
                                ? "border-indigo-400 bg-indigo-50/60"
                                : "border-slate-300 bg-slate-50 hover:border-indigo-400 hover:bg-indigo-50/60"
                            }`}
                            onClick={() => imageInputRef.current?.click()}
                            onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); setIsImageDragOver(true); }}
                            onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); setIsImageDragOver(true); }}
                            onDragLeave={(e) => { e.preventDefault(); e.stopPropagation(); setIsImageDragOver(false); }}
                            onDrop={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setIsImageDragOver(false);
                              applyImageFile(e.dataTransfer.files?.[0]);
                            }}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                imageInputRef.current?.click();
                              }
                            }}
                          >
                            <FiUploadCloud size={28} className="text-indigo-500" />
                            <p className="m-0 text-slate-700 text-xs sm:text-sm font-bold">Drag & drop image here</p>
                            <p className="m-0 text-slate-500 text-xs font-medium">or click to browse · Max {MAX_IMAGE_SIZE_MB} MB</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lead-modal-footer">
                <button
                  type="button"
                  className="px-4 py-2 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 text-sm font-semibold rounded-lg transition-colors cursor-pointer mr-1"
                  onClick={toggleModal}
                >
                  Close
                </button>

                <button
                  type="submit"
                  className="px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 cursor-pointer"
                >
                  {product?.productID ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {openCategoryModal && (<AddCategory setOpenCategoryModal={setOpenCategoryModal} />)}
    </>
  );
}
